/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmitContactMessageRequest as ModelsSubmitContactMessageRequest } from '../../models/models/submit-contact-message-request';
import { SubmitContactMessageResponse as ModelsSubmitContactMessageResponse } from '../../models/models/submit-contact-message-response';

export interface ApiV1BorContactMessagesPost$Params {
  
    /**
     * Contact message
     */
    body: ModelsSubmitContactMessageRequest
}

export function apiV1BorContactMessagesPost(http: HttpClient, rootUrl: string, params: ApiV1BorContactMessagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSubmitContactMessageResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1BorContactMessagesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSubmitContactMessageResponse>;
    })
  );
}

apiV1BorContactMessagesPost.PATH = '/api/v1/bor/contact-messages';
